<template>
  <div>
    <div ref="panelWidget" class="panel"></div>
    <div ref="gridWidget"></div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  props: {
    title: {
      type: String
    },
    label: {
      type: Object
    },
    dataSource: {
      type: Object
    },
    height: {
      type: Number,
      default: 340
    }
  },

  data () {
    const config = {
      theme: 'bootstrap',
      excel: {
        allPages: true
      },
      sortable: true,
      dataSource: this.dataSource,
      pageable: {
        refresh: true,
        pageSizes: true
      },
      height: this.height
    };

    if (this.dataSource) {
      if (_.isArray(this.dataSource)) {
        config.dataSource.data = this.dataSource;
      } else {
        config.dataSource = this.dataSource;
      }
    }

    return {
      config,
      image: undefined,
      gridWidget: undefined,
      panelWidget: undefined
    };
  },

  methods: {
    exportTable () {
      this.gridWidget.saveAsExcel();
    }
  },

  mounted () {
    this.gridWidget = new kendo.ui.PivotGrid(this.$refs.gridWidget, this.config);
    this.panelWidget = new kendo.ui.PivotConfigurator(this.$refs.panelWidget, {
      dataSource: this.gridWidget.dataSource,
      filterable: true,
      height: this.config.height
    });
  },

  destroyed () {
    this.gridWidget.destroy();
    this.panelWidget.destroy();
  },

  watch: {
    dataSource (val) {
      this.gridWidget.setDataSource(new kendo.data.PivotDataSource(val));
      this.panelWidget.setDataSource(this.gridWidget.dataSource);
    }
  }
};
</script>

<style lang="scss" scoped>
  .panel {
    float: left;
    z-index: 1;
    border-bottom: none;
  }
</style>
